import ProductPackageService from "@/app/services/ProductPackageService.js"
import { types } from "@/app/types/types";
import { importProductPackagesAndGroupsModeEnum } from "@/app/enums/common";

const state =
{
	[types.STATE_PRODUCTPACKAGES]: []
};

const getters =
{
	[types.GET_PRODUCTPACKAGES]: (state) =>
	{
		return state[types.STATE_PRODUCTPACKAGES]
	},

	[types.GET_PRODUCTPACKAGE]: (state) => id =>
	{
		var productpackages = state[types.STATE_PRODUCTPACKAGES];

		for (const productpackage of productpackages)
		{
			if (productpackage.id == id)
				return productpackage;
		}

		return null;
	}
};

const mutations =
{
	[types.MUTATE_LOAD_PRODUCTPACKAGES]: (state, payload) =>
	{
		// TODO: Do paging here
		state[types.STATE_PRODUCTPACKAGES] = payload
	},

	[types.MUTATE_ADD_PRODUCTPACKAGE]: (state, payload) =>
	{
		state[types.STATE_PRODUCTPACKAGES].push(payload);
	},

	[types.MUTATE_UPDATE_PRODUCTPACKAGE]: (state, payload) =>
	{
		//let index = state[types.STATE_PRODUCTPACKAGES].findIndex(productpackage => productpackage.id == payload.id)
		//state[types.STATE_PRODUCTPACKAGES].splice(index, 1, payload)
		let productpackage = state[types.STATE_PRODUCTPACKAGES].find((productpackage) => { return productpackage.id == payload.id });

		if (productpackage)
		{
			productpackage = payload
		}
	},

	[types.MUTATE_DELETE_PRODUCTPACKAGE]: (state, payload) =>
	{
		//let index = state[types.STATE_PRODUCTPACKAGES].findIndex(productpackage => productpackage.id == payload.id)
		//state[types.STATE_PRODUCTPACKAGES].splice(index, 1)
		state[types.STATE_PRODUCTPACKAGES] = state[types.STATE_PRODUCTPACKAGES].filter((productpackage) => { return productpackage.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_PRODUCTPACKAGES]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTPACKAGES, payload: payload })
		
		return ProductPackageService.getProductPackages(payload).then(response =>
		{
			commit(types.MUTATE_LOAD_PRODUCTPACKAGES, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTPACKAGES, message: error, payload: payload });
			return error.response
		});
	},

	[types.ACTION_GET_PRODUCTPACKAGE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTPACKAGE, payload: payload })

		return ProductPackageService.getProductPackage(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PRODUCTPACKAGE, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_PRODUCTPACKAGE, message: error });
			return error.response
		});
	},

	[types.ACTION_ADD_PRODUCTPACKAGE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_PRODUCTPACKAGE, payload: payload })

		return ProductPackageService.addProductPackage(payload).then(response =>
		{
			commit(types.MUTATE_ADD_PRODUCTPACKAGE, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_PRODUCTPACKAGE, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_UPDATE_PRODUCTPACKAGE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_PRODUCTPACKAGE, payload: payload })

		return ProductPackageService.updateProductPackage(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_PRODUCTPACKAGE, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_PRODUCTPACKAGE, message: error.response.statusText, payload: payload });
			return error.response
		});
	},

	[types.ACTION_DELETE_PRODUCTPACKAGE]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_PRODUCTPACKAGE, payload: payload })

		return ProductPackageService.deleteProductPackage(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_PRODUCTPACKAGE, payload);
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_PRODUCTPACKAGE, message: error.response.statusText, payload: payload });
			return error.response
		});
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
